import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatCellDef, MatColumnDef, MatHeaderRow, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedCaseManagementService } from '../../services/shared-case-management.service';

@Component({
  selector: 'app-eg-table',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatColumnDef,
    MatButtonModule,
    MatSortModule,
    MatIconModule,
    MatMenuModule,
    MatCellDef,
    MatColumnDef,
    MatHeaderRow,
    MatPaginator,
    MatCheckboxModule,
    MatProgressBarModule,
    MatTooltipModule
  ],
  templateUrl: './eg-table.component.html',
  styleUrls: ['./eg-table.component.scss']
})
export class EgTableComponent {
  @Input() data: any;
  @Input() columns: any;
  @Input() columnKeyValues: any;
  @Input() start: any;
  @Input() end: any;
  @Input() pageSize: any;
  @Input() totalElements: any;
  @Input() pageIndex: any;
  @Input() serverSidePagination: any;
  @Input() multiselectcheckbox: boolean = false; // New input property
  @Input() showSortIcon: boolean = false;
  @Input() moduleName : string = '';
  dataSource: any;
  @Output() btnClicked = new EventEmitter<any>();
  @Output() pageEvent = new EventEmitter<any>();
  @Input() isAddEditApplicantAllowed: boolean = false;
  @Output() renewalClicked = new EventEmitter<any>();
  @Output() printRenewalClicked = new EventEmitter<any>();

  selection = new SelectionModel<any>(true, []);
  combinedColumns: string[] = [];
  isEligibilityAutoDetermined: boolean = false;
  isSuperAdmin: boolean = false;

  constructor(private readonly sharedManagementService: SharedCaseManagementService) {}
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  ngAfterViewInit() {
    if (this.data instanceof MatTableDataSource) {
      this.data.sort = this.sort;
      if (!this.serverSidePagination) {
        this.dataSource.paginator = this.paginator;
      }
    }
  }
  filteredData: any;
  ngOnChanges(changes: SimpleChanges) {
    this.filteredData = this.data?.slice(this.start, this.pageSize);
    this.dataSource = this.serverSidePagination ? new MatTableDataSource(this.filteredData) : new MatTableDataSource(this.data);
    this.combinedColumns = this.multiselectcheckbox ? ['select', ...this.columnKeyValues] : [...this.columnKeyValues];
    this.isEligibilityAutoDetermined = sessionStorage.getItem('isEligibilityAutoDetermined') == 'true';
    if(sessionStorage.getItem('isSuperAdmin')) {
      this.isSuperAdmin = sessionStorage.getItem('isSuperAdmin') == 'true';
    }
  }
  sortApplications(sort: Sort) {
    this.dataSource.sort = this.sort;
  }
  emitUserData(param: any, element: any) {
    this.btnClicked.emit({ 'param': param, 'element': element });
  }
  emitApplicationData(completionStatus: any, applicationId: any, downloadStatus: any, terminateStatus: any, workflowStatusId: any) {
    this.btnClicked.emit({ 'completionStatus': completionStatus, 'applicationId': applicationId, downloadStatus: downloadStatus, terminateStatus: terminateStatus, workflowStatusId: workflowStatusId });
  }
  emitApplicantData(applicantAction: any, applicantId: any) {
    this.btnClicked.emit({ applicantAction, applicantId });
  }
  beginRenewal(element: any) {
    this.renewalClicked.emit(element);
  }
  printRenewalLetter(element: any) {
    this.printRenewalClicked.emit(element);
  }
  getPaginatorData(event: any) {
    this.pageSize = event.pageSize;
    this.pageEvent.emit(event);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  getProgressBarStyles(timeConsumedInPercentage: number): { [key: string]: string } {
    return this.sharedManagementService.getProgressBarStyles(timeConsumedInPercentage);
  }

  getProgressBarContainerStyles(timeConsumedInPercentage: number): { [key: string]: string } {
    return this.sharedManagementService.getProgressBarContainerStyles(timeConsumedInPercentage);
  }

  getProgressBackgroundStyles(timeConsumedInPercentage: number): { [key: string]: string } {
    return this.sharedManagementService.getProgressBackgroundStyles(timeConsumedInPercentage);
  }
  
  getCombinedProgressStyles(percent: number): { [key: string]: string } {
  return {
    ...this.getProgressBarContainerStyles(percent),
    ...this.getProgressBackgroundStyles(percent)
  };
}

  
  emitCaseData(action: any, element: any) {
    this.btnClicked.emit({ action: action, element : element });
  }

  sortColumn(columnKey: string) {
    let sortState: Sort;

    if (this.sort.active === columnKey) {
      if (this.sort.direction === 'asc') {
        sortState = { active: columnKey, direction: 'desc' };
      } else if (this.sort.direction === 'desc') {
        sortState = { active: columnKey, direction: '' };
      } else {
        sortState = { active: columnKey, direction: 'asc' };
      }
    } else {
      sortState = { active: columnKey, direction: 'asc' };
    }

    this.sort.active = sortState.active;
    this.sort.direction = sortState.direction;
    this.sort.sortChange.emit(sortState);
  }
}